import { render, staticRenderFns } from "./PortalContentCard.vue?vue&type=template&id=2f2b661c&scoped=true&"
import script from "./PortalContentCard.vue?vue&type=script&lang=js&"
export * from "./PortalContentCard.vue?vue&type=script&lang=js&"
import style0 from "./PortalContentCard.vue?vue&type=style&index=0&id=2f2b661c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2b661c",
  null
  
)

export default component.exports